<div id="tid-ez-lr-placement-container">
    <div class="tid-ez-lrp-col" id="tid-ez-lrp-left">
        <fa-icon *ngIf="isLeftPlacement" icon="circle"></fa-icon>
    </div>
    <div class="tid-ez-lrp-col" id="tid-ez-lrp-hole">{{pinSheet.greenName}}</div>
    <div class="tid-ez-lrp-col" id="tid-ez-lrp-right">
        <fa-icon *ngIf="isRightPlacement" icon="circle"></fa-icon>
    </div>
</div>
